(ns ui.view.sheets.view
  (:require
   [re-frame.core :as rf]
   [ui.util :as uu]
   [ui.view.sheets.event :as event]
   [ui.view.sheets.primitives :as sheet-primitives]
   [ui.view.sheets.sub :as sub]
   [ui.view.counterparty-diligence.responder-form.model :as counterparty-diligence-responder-form-model]
   [ui.view.counterparty-diligence.responder-form.view :as counterparty-diligence-responder-form-view]))

(def content-components
  {counterparty-diligence-responder-form-model/sheet-view-key counterparty-diligence-responder-form-view/sheet-view})

(defn sheet-component
  [{:keys [sheet-key open? position topmost? sheet-count
           sheets-before topmost-sheet-width] :as args}]
  (let [content-z-index (- 10000 (* position 2))
        overlay-z-index (- content-z-index 1)
        content-component (get content-components sheet-key)]
    [sheet-primitives/sheet
     {:open         open?
      :onOpenChange (fn [_open?])
      :modal        true}
     [sheet-primitives/sheet-portal
      [sheet-primitives/sheet-overlay
       {:style             {:z-index (str overlay-z-index)}
        :forceMount        true
        :data-show-overlay (if topmost?
                             "true"
                             "false")
        :class
        (uu/cm "fixed inset-0 data-[show-overlay=true]:bg-black/40 data-[show-overlay=false]:bg-black/0 transition duration-0 transition-all ease-linear"
               (when (<= sheet-count 1)
                 "data-[show-overlay=true]:animate-in data-[show-overlay=false]:animate-out data-[show-overlay=false]:fade-out-0 transition transition-all duration-500 data-[show-overlay=true]:animate-in data-[show-overlay=false]:animate-out"))}]
      [sheet-primitives/sheet-content
       {:class (uu/cm
                "fixed border overflow-hidden overflow-y-auto bg-base-light gap-4 shadow-lg transition ease-in-out data-[state=closed]:duration-200 data-[state=open]:duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out"
                "inset-y-0 h-full border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right transition-all"
                "rounded-l-lg")
        :style {:right     "0px"
                :width     topmost-sheet-width
                :z-index   (str content-z-index)
                :transform (if-not topmost?
                             (str "translateX(-" (* 8 sheets-before) "%) scale(" (max 0 (- 1.0 (* sheets-before 0.05))) ")")
                             "")}}
       [:div
        {:class "flex flex-col h-full max-h-full overflow-hidden"}
        [content-component args]]]]]))

(defn sheet-stack
  []
  (let [sheets @(rf/subscribe [::sub/sheets])]
    [:div
     (->> sheets
          reverse
          (map
           (fn [sheet-config]
             (let [id (:id sheet-config)]
               ^{:key (str id)}
               [sheet-component
                (assoc sheet-config
                       :close-sheet-event [::event/close-sheet id])])))
          doall)]))
